module.exports = __webpack_public_path__ + "img/arrow-down.3ae6df4f.svg";